import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/activity/119967/introduce_icon.png';
import _imports_1 from '@assets/images/activity/nft_list_bg_t.png';
import _imports_2 from '@assets/images/activity/nft-img-icon.png';
import _imports_3 from '@assets/images/activity/nft-img-icon_more.png';
import _imports_4 from '@assets/images/activity/nft_list_bg_b.png';
const _withScopeId = n => (_pushScopeId("data-v-91f18bae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "cba-box"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "top-box"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"nft-introduce\" data-v-91f18bae><div class=\"introduce-title\" data-v-91f18bae>藏品合成步骤</div><div class=\"introduce-step\" data-v-91f18bae><div data-v-91f18bae>选择合成玩法</div><img src=\"" + _imports_0 + "\" data-v-91f18bae><div data-v-91f18bae>选择参与合成的藏品</div><img src=\"" + _imports_0 + "\" data-v-91f18bae><div data-v-91f18bae>点击合成按钮</div></div><div class=\"introduce-tips\" data-v-91f18bae>合成操作不可逆，参与合成前请仔细阅读合成活动规则</div></div>", 1);
const _hoisted_5 = {
  class: "nft-btns"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "margin-top": "-4px"
  }
}, null, -1));
const _hoisted_7 = {
  key: 0,
  class: "nft-list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "img-box"
};
const _hoisted_10 = {
  class: "img-info"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 0,
  class: "nft-item-seq"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "more",
  src: _imports_3
}, null, -1));
const _hoisted_15 = {
  class: "render-line-clamp nft-item-name"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 0,
  class: "nft-btn nft-btn-gray nft-btn-light"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "藏品合成", -1));
const _hoisted_19 = {
  key: 2,
  class: "nft-btn nft-btn-gray"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "藏品合成", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "活动已结束", -1));
const _hoisted_22 = [_hoisted_20, _hoisted_21];
const _hoisted_23 = {
  key: 1,
  class: "nft-list"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  class: "img-box"
};
const _hoisted_26 = {
  class: "img-info"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  key: 0,
  class: "nft-item-seq"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "more",
  src: _imports_3
}, null, -1));
const _hoisted_31 = {
  class: "render-line-clamp nft-item-name"
};
const _hoisted_32 = {
  key: 0
};
const _hoisted_33 = {
  key: 0,
  class: "nft-btn nft-btn-gray nft-btn-light"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "藏品合成", -1));
const _hoisted_35 = {
  key: 2,
  class: "nft-btn nft-btn-gray"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "藏品合成", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "活动已结束", -1));
const _hoisted_38 = [_hoisted_36, _hoisted_37];
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_40 = {
  class: "merger-list"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_42 = {
  class: "merger-item-r"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "tit"
}, "藏品合成成功", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "恭喜您获得“实体生肖剪纸”", -1));
const _hoisted_45 = ["onClick"];
const _hoisted_46 = ["onClick"];
const _hoisted_47 = ["onClick"];
const _hoisted_48 = {
  key: 1
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "开奖倒计时：", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_51 = {
  class: "merger-item-l"
};
const _hoisted_52 = {
  class: "img-box"
};
const _hoisted_53 = ["src"];
const _hoisted_54 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_AddressEdit = _resolveComponent("AddressEdit");
  const _component_AddressShow = _resolveComponent("AddressShow");
  const _component_CompLoading = _resolveComponent("CompLoading");
  const _component_CompSeqList = _resolveComponent("CompSeqList");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: $data.activityData.bg_top
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass(['btn-l', {
      'btn-l-active': $data.btnActive == 1
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $data.btnActive = 1)
  }, "合成金色十二生肖", 2), _createElementVNode("div", {
    class: _normalizeClass(['btn-r', {
      'btn-r-active': $data.btnActive == 2
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $data.btnActive = 2)
  }, "合成龙凤呈祥", 2)]), _hoisted_6, $data.btnActive == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", {
    class: _normalizeClass(['list', {
      'list-5': $data.nfts.length == 5
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nfts, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['nft-item', `nft-item-${$data.nfts.length}`, 'nft-item-num']),
      onClick: $event => $options.goToChoseSeq(item.seq_hash_list, item.img_url, index, item.title)
    }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
      src: `${_ctx.$imgUrlFilter(item.img_url, 200 * $options.ratio)}${_ctx.$imgUrlFilter(item.img_url, 200 * $options.ratio).includes('?') ? '/' : '?'}${item.num > 2 ? '' : 'bright,-50/contrast,-50'}`
    }, null, 8, _hoisted_11)]), item.seq_hash_list && item.seq_hash_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", null, _toDisplayString(item.seq_list && item.seq_list.length == 3 ? '已选3个' : item.seq_hash_list[0].seq), 1), _hoisted_14])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, _toDisplayString(item.title), 1), item.num > 0 ? (_openBlock(), _createElementBlock("i", _hoisted_16, _toDisplayString(item.num), 1)) : _createCommentVNode("", true)], 10, _hoisted_8);
  }), 128))], 2), $data.link_url ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nft-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goToLink && $options.goToLink(...args))
  }, "前往收集")) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_hoisted_18, _createElementVNode("p", null, "合成即将开启 " + _toDisplayString($data.times_show), 1)])) : $data.status == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$data.isLogin ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nft-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.goToLogin && $options.goToLogin(...args))
  }, "藏品合成")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "nft-btn",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goMerge && $options.goMerge(...args))
  }, "藏品合成"))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))], 64)), _createElementVNode("div", {
    class: _normalizeClass(['nft-list-tips', {
      'nft-list-tips-error': $data.mergeTips
    }])
  }, _toDisplayString($data.mergeTips ? $data.mergeTips : '点击藏品序列号，可选择指定藏品合成'), 3)])) : _createCommentVNode("", true), $data.btnActive == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", {
    class: _normalizeClass(['list', {
      'list-5': $data.nfts_six.length == 5
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.nfts_six, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['nft-item', `nft-item-${$data.nfts_six.length}`, 'nft-item-num']),
      onClick: $event => $options.goToChoseSeq(item.seq_hash_list, item.img_url, index, item.title)
    }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
      src: `${_ctx.$imgUrlFilter(item.img_url, 200 * $options.ratio)}${_ctx.$imgUrlFilter(item.img_url, 200 * $options.ratio).includes('?') ? '/' : '?'}${item.num > 0 ? '' : 'bright,-50/contrast,-50'}`
    }, null, 8, _hoisted_27)]), item.seq_hash_list && item.seq_hash_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", null, _toDisplayString(item.seq_list && item.seq_list.length ? `已选${item.seq_list.length}个` : item.seq_hash_list[0].seq), 1), _hoisted_30])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_31, _toDisplayString(item.title), 1), item.num > 0 ? (_openBlock(), _createElementBlock("i", _hoisted_32, _toDisplayString(item.num), 1)) : _createCommentVNode("", true)], 10, _hoisted_24);
  }), 128))], 2), $data.link_url ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nft-btn",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.goToLink && $options.goToLink(...args))
  }, "前往收集")) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_hoisted_34, _createElementVNode("p", null, "合成即将开启 " + _toDisplayString($data.times_show), 1)])) : $data.status == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!$data.isLogin ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "nft-btn",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.goToLogin && $options.goToLogin(...args))
  }, "藏品合成")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "nft-btn",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.goMerge && $options.goMerge(...args))
  }, "藏品合成"))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_38))], 64)), _createElementVNode("div", {
    class: _normalizeClass(['nft-list-tips', {
      'nft-list-tips-error': $data.mergeTips
    }])
  }, _toDisplayString($data.mergeTips ? $data.mergeTips : '点击藏品序列号，可选择指定藏品合成'), 3)])) : _createCommentVNode("", true), _hoisted_39, _createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.merger_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "merger-item"
    }, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_hoisted_43, item.open_prize_status == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [], 64)) : item.open_prize_status == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [item.prize_status == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_44, item.address_status == 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "address-btn",
      onClick: $event => $options.showPopupEdit(item, 'add')
    }, "填写收货地址", 8, _hoisted_45)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [item.fill_over_time == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "address-btn",
      onClick: $event => $options.showPopupEdit(item, 'disabled')
    }, "收货地址", 8, _hoisted_46)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "address-btn",
      onClick: $event => $options.showPopupEdit(item, 'edit')
    }, "收货地址", 8, _hoisted_47))], 64))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_48, "未中奖"))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_hoisted_49, _createElementVNode("div", null, _toDisplayString($data.time_seconds), 1)], 64))]), _hoisted_50, _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", {
      class: "img-info",
      style: _normalizeStyle(`background-image: url(${_ctx.$imgUrlFilter(item.img_url, 200 * $options.ratio)})`)
    }, null, 4)])])]);
  }), 128))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.activityData.rulesImgs, (item, index) => {
    return _openBlock(), _createElementBlock("img", {
      key: index,
      class: "img",
      src: item
    }, null, 8, _hoisted_53);
  }), 128)), _createElementVNode("img", {
    src: $data.activityData.bg_bottom
  }, null, 8, _hoisted_54), _createVNode(_component_AddressEdit, {
    show_edit: $data.showEdit,
    "onUpdate:show_edit": _cache[8] || (_cache[8] = $event => $data.showEdit = $event),
    stock_hash: $data.stock_hash,
    relation_id: $data.relation_id,
    address_type: $data.address_type,
    address_info: $data.address_info,
    prize_activity_id: $data.prize_activity_id,
    fill_end_time: $data.fill_end_time,
    describe: $data.describe,
    onGetMerger: $options.getMerger
  }, null, 8, ["show_edit", "stock_hash", "relation_id", "address_type", "address_info", "prize_activity_id", "fill_end_time", "describe", "onGetMerger"]), _createVNode(_component_AddressShow, {
    show: $data.show,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $data.show = $event),
    address_info: $data.address_info
  }, null, 8, ["show", "address_info"]), _createVNode(_component_CompLoading, {
    ref: "loadingBox",
    loading: $data.loading,
    "onUpdate:loading": _cache[10] || (_cache[10] = $event => $data.loading = $event),
    loading_time: $data.loading_time
  }, null, 8, ["loading", "loading_time"]), _createVNode(_component_CompSeqList, {
    show_seq: $data.show_seq,
    "onUpdate:show_seq": _cache[11] || (_cache[11] = $event => $data.show_seq = $event),
    father_seq_list_checked: $data.seq_list_checked,
    "onUpdate:father_seq_list_checked": _cache[12] || (_cache[12] = $event => $data.seq_list_checked = $event),
    seq_list: $data.seq_list,
    seq_url: $data.seq_url,
    seq_tit: $data.seq_tit,
    type: $data.btnActive,
    father_checked_nums: $data.father_checked_list.length || 0,
    father_checked_list: $data.father_checked_list,
    onGetCheckSeq: $options.getCheckSeq
  }, null, 8, ["show_seq", "father_seq_list_checked", "seq_list", "seq_url", "seq_tit", "type", "father_checked_nums", "father_checked_list", "onGetCheckSeq"])]));
}